document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

if (menuToggle && mobileMenu) {
  menuToggle.addEventListener('click', () => {
    const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
    mobileMenu.hidden = isOpen;
    document.body.classList.toggle('menu-open', !isOpen);
  });

  mobileMenu.addEventListener('click', (event) => {
    if (!event.target.closest('a')) return;
    menuToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.hidden = true;
    document.body.classList.remove('menu-open');
  });
}

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('[data-gallery-track]');
  const slides = Array.from(gallery.querySelectorAll('[data-media-id]'));
  const thumbnails = Array.from(gallery.querySelectorAll('[data-media-target]'));
  const thumbnailStrip = gallery.querySelector('[data-gallery-thumbnails]');
  const previousButton = gallery.querySelector('[data-gallery-prev]');
  const nextButton = gallery.querySelector('[data-gallery-next]');

  if (!track || slides.length === 0) return;

  let activeIndex = 0;
  let pointerStart = null;

  const showSlide = (requestedIndex) => {
    activeIndex = (requestedIndex + slides.length) % slides.length;
    track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;

    slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', String(index !== activeIndex));
    });

    thumbnails.forEach((thumbnail, index) => {
      const isActive = index === activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      if (isActive) {
        thumbnail.setAttribute('aria-current', 'true');
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });

    const activeThumbnail = thumbnails[activeIndex];
    if (thumbnailStrip && activeThumbnail) {
      const targetLeft = activeThumbnail.offsetLeft - (thumbnailStrip.clientWidth - activeThumbnail.offsetWidth) / 2;
      thumbnailStrip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    }
  };

  thumbnails.forEach((button, index) => {
    button.addEventListener('click', () => showSlide(index));
  });

  previousButton?.addEventListener('click', () => showSlide(activeIndex - 1));
  nextButton?.addEventListener('click', () => showSlide(activeIndex + 1));

  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
    if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
  });

  track.addEventListener('pointerdown', (event) => {
    pointerStart = event.clientX;
  });

  track.addEventListener('pointerup', (event) => {
    if (pointerStart === null) return;
    const distance = event.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(distance) < 45) return;
    showSlide(activeIndex + (distance < 0 ? 1 : -1));
  });

  track.addEventListener('pointercancel', () => {
    pointerStart = null;
  });

  showSlide(0);
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const productJson = section.querySelector('[data-product-json]');
  const variantSelect = section.querySelector('[data-variant-select]');
  const form = section.querySelector('.product-form');

  if (!productJson || !variantSelect || !form) return;

  const variants = JSON.parse(productJson.textContent);
  const optionInputs = Array.from(form.querySelectorAll('input[name^="options["]'));

  const updateVariant = () => {
    const selectedOptions = [];
    const names = [...new Set(optionInputs.map((input) => input.name))];

    names.forEach((name) => {
      const checked = form.querySelector(`input[name="${CSS.escape(name)}"]:checked`);
      if (checked) selectedOptions.push(checked.value);
    });

    const variant = variants.find((candidate) =>
      candidate.options.every((option, index) => option === selectedOptions[index])
    );

    if (!variant) return;
    variantSelect.value = variant.id;
    const selectedVariantOption = variantSelect.options[variantSelect.selectedIndex];
    const submit = form.querySelector('[name="add"]');
    const currentPrice = section.querySelector('[data-current-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const availability = section.querySelector('[data-variant-availability]');

    if (currentPrice && selectedVariantOption?.dataset.price) {
      currentPrice.textContent = selectedVariantOption.dataset.price;
    }

    if (comparePrice) {
      const compareValue = selectedVariantOption?.dataset.comparePrice || '';
      comparePrice.textContent = compareValue;
      comparePrice.hidden = !compareValue;
    }

    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Megrendelem' : 'Elfogyott';
    }

    if (availability) {
      availability.classList.toggle('is-unavailable', !variant.available);
      const label = availability.querySelector('strong');
      if (label) label.textContent = variant.available ? 'Készleten' : 'Jelenleg nem elérhető';
    }
  };

  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  updateVariant();
});

document.querySelectorAll('[data-hero-testimonials]').forEach((slider) => {
  const track = slider.querySelector('[data-hero-testimonial-track]');
  const slides = Array.from(slider.querySelectorAll('.cat-hero__testimonial-slide'));
  const dots = Array.from(slider.querySelectorAll('[data-hero-testimonial-dot]'));
  if (!track || slides.length < 2) return;

  let activeIndex = 0;
  let autoplay;
  let drag = null;

  const showSlide = (requestedIndex) => {
    activeIndex = (requestedIndex + slides.length) % slides.length;
    track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
    slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== activeIndex)));
    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      if (isActive) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  const startAutoplay = () => {
    window.clearInterval(autoplay);
    autoplay = window.setInterval(() => showSlide(activeIndex + 1), 6500);
  };

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      showSlide(index);
      startAutoplay();
    });
  });

  track.style.touchAction = 'pan-y';
  track.addEventListener('pointerdown', (event) => {
    if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
    window.clearInterval(autoplay);
    drag = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, horizontal: false };
    track.setPointerCapture(event.pointerId);
    track.style.transition = 'none';
    slider.classList.add('is-dragging');
  });
  track.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x;
    const dy = event.clientY - drag.y;
    if (!drag.horizontal && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) drag.horizontal = true;
    if (!drag.horizontal) return;
    drag.dx = dx;
    track.style.transform = `translate3d(calc(-${activeIndex * 100}% + ${dx}px), 0, 0)`;
  });
  const finishDrag = (event) => {
    if (!drag || event.pointerId !== drag.id) return;
    const gesture = drag;
    drag = null;
    track.style.transition = '';
    slider.classList.remove('is-dragging');
    if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    const threshold = Math.min(70, slider.clientWidth * 0.15);
    showSlide(activeIndex + (event.type !== 'pointercancel' && gesture.horizontal && Math.abs(gesture.dx) >= threshold ? (gesture.dx < 0 ? 1 : -1) : 0));
    if (event.pointerType !== 'mouse' || !slider.matches(':hover')) startAutoplay();
  };
  track.addEventListener('pointerup', finishDrag);
  track.addEventListener('pointercancel', finishDrag);
  track.addEventListener('lostpointercapture', finishDrag);
  track.addEventListener('dragstart', (event) => event.preventDefault());
  slider.tabIndex = 0;
  slider.setAttribute('aria-label', 'Gazdik véleményei – húzással vagy nyílbillentyűkkel lapozható');
  slider.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    showSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    window.clearInterval(autoplay);
  });

  slider.addEventListener('mouseenter', () => window.clearInterval(autoplay));
  slider.addEventListener('mouseleave', startAutoplay);
  showSlide(0);
  startAutoplay();
});

document.querySelectorAll('[data-home-faq-toggle]').forEach((toggle) => {
  const faqSection = toggle.closest('.kitty-home-faq');
  const extraQuestions = Array.from(faqSection?.querySelectorAll('.kitty-home-faq__extra') || []);
  const label = toggle.querySelector('[data-home-faq-label]');
  if (!faqSection || !extraQuestions.length || !label) return;

  const moreLabel = label.textContent.trim();
  const lessLabel = faqSection.dataset.lessLabel || 'Kevesebb kérdés';

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    extraQuestions.forEach((question) => {
      question.hidden = expanded;
      if (expanded) question.removeAttribute('open');
    });
    toggle.setAttribute('aria-expanded', String(!expanded));
    label.textContent = expanded ? moreLabel : lessLabel;
  });
});

document.querySelectorAll('[data-horizontal-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-horizontal-track]');
  const previousButton = carousel.querySelector('[data-scroll-prev]');
  const nextButton = carousel.querySelector('[data-scroll-next]');
  if (!track) return;

  const scroll = (direction) => {
    track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
  };

  previousButton?.addEventListener('click', () => scroll(-1));
  nextButton?.addEventListener('click', () => scroll(1));
});
